(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const slotLabels = {
    main: 'Ana Fotoğraf',
    'small-1': 'Küçük Fotoğraf 1',
    'small-2': 'Küçük Fotoğraf 2',
    'small-3': 'Küçük Fotoğraf 3',
  };
  const slotFallbackLabels = {
    main: 'Ana fotoğraf',
    'small-1': 'Küçük fotoğraf 1',
    'small-2': 'Küçük fotoğraf 2',
    'small-3': 'Küçük fotoğraf 3',
  };
  const getPropertyNameFromInput = (input) => {
    const match = String(input?.name || '').match(/^properties\[(.*)]$/);
    return match ? match[1] : '';
  };

  const initNetflixPersonalizer = (root) => {
    const preview = root.querySelector('[data-renao-netflix-preview]');
    const poster = root.querySelector('[data-renao-netflix-poster]');
    const proofOpen = root.querySelector('[data-renao-netflix-proof-open]');
    const proofModal = root.querySelector('[data-renao-netflix-proof-modal]');
    const proofStage = root.querySelector('[data-renao-netflix-proof-stage]');
    const proofCloseButtons = root.querySelectorAll('[data-renao-netflix-proof-close]');
    const cropModal = root.querySelector('[data-renao-netflix-crop]');
    const cropStage = root.querySelector('[data-renao-netflix-crop-stage]');
    const cropImage = root.querySelector('[data-renao-netflix-crop-image]');
    const cropZoom = root.querySelector('[data-renao-netflix-crop-zoom]');
    const cropApply = root.querySelector('[data-renao-netflix-crop-apply]');
    const cropCancelButtons = root.querySelectorAll('[data-renao-netflix-crop-cancel]');
    const cropMoveButtons = root.querySelectorAll('[data-renao-netflix-crop-move]');
    const cropZoomStepButtons = root.querySelectorAll('[data-renao-netflix-crop-zoom-step]');
    const cropReset = root.querySelector('[data-renao-netflix-crop-reset]');
    const orderStatus = root.querySelector('[data-renao-netflix-order-status]');
    const textInputs = Array.from(root.querySelectorAll('[data-renao-netflix-text-input]'));
    const dateToggle = root.querySelector('[data-renao-netflix-date-toggle]');
    const menuColorInputs = Array.from(root.querySelectorAll('[data-renao-netflix-menu-color]'));
    const charCounters = Array.from(root.querySelectorAll('[data-renao-netflix-char-count]'));
    const previewOriginalParent = preview?.parentElement || null;
    const previewOriginalNext = preview?.nextSibling || null;
    const isTabloNetflixLayout = root.dataset.renaoNetflixLayout === 'tablonetflix';
    const initialMenuColor = menuColorInputs.find((input) => input.checked)?.value || '';
    let hasActivatedTabloPreview = false;

    if (!preview || !poster) return;
    if (proofModal && proofModal.parentElement !== document.body) document.body.appendChild(proofModal);
    if (cropModal && cropModal.parentElement !== document.body) document.body.appendChild(cropModal);
    if (cropImage) cropImage.draggable = false;

    const slots = Array.from(root.querySelectorAll('[data-renao-netflix-photo-input]')).map((input) => {
      const slot = input.dataset.renaoNetflixSlot;
      return {
      slot,
      input,
      propertyName: getPropertyNameFromInput(input),
      upload: root.querySelector(`[data-renao-netflix-upload-slot="${slot}"]`),
      slotElement: root.querySelector(`[data-renao-netflix-upload-slot="${slot}"]`),
      pick: root.querySelector(`[data-renao-netflix-photo-button="${slot}"]`),
      adjust: root.querySelector(`[data-renao-netflix-photo-adjust="${slot}"]`),
      fileName: root.querySelector(`[data-renao-netflix-file-name="${slot}"]`),
      frame: poster.querySelector(`[data-renao-netflix-photo-frame="${slot}"]`),
      image: poster.querySelector(`[data-renao-netflix-image-slot="${slot}"]`),
      position: root.querySelector(`[data-renao-netflix-position="${slot}"]`),
      file: null,
      objectUrl: '',
      existingUrl: '',
      preserveInput: null,
      scale: 1,
      x: 0,
      y: 0,
      referenceWidth: 0,
      referenceHeight: 0,
      };
    }).filter((slotState) => slotState.slot);

    root.dataset.renaoFileManaged = 'true';
    root.renaoHasManagedFiles = () => slots.some((slotState) => (
      Boolean(slotState.file)
      || Boolean(slotState.input?.__renaoPendingFile instanceof File && slotState.input.__renaoPendingFile.size > 0)
      || Boolean(slotState.input?.files && slotState.input.files.length > 0)
    ));
    root.renaoAppendManagedFiles = (formData) => {
      if (!formData) return false;
      let appended = false;
      slots.forEach((slotState) => {
        const file = slotState.file || slotState.input?.__renaoPendingFile || slotState.input?.files?.[0] || null;
        const fieldName = slotState.input?.name;
        if (!file || !fieldName) return;
        formData.delete(fieldName);
        formData.append(fieldName, file, file.name || `${slotState.propertyName || slotState.slot}.jpg`);
        appended = true;
      });
      return appended;
    };

    let activeSlot = null;
    let dragState = null;
    let draggedSlot = null;
    const defaultOrderHint = 'Sıralamak için küçük fotoğraf kartını tutup sürükleyin.';

    const getProductMediaWrapper = () => {
      const product = root.closest('.product') || document.querySelector('.product');
      return product ? product.querySelector('.product__media-wrapper') : null;
    };

    const getProductForm = () => root.closest('form');

    const fitSingleLineText = (element) => {
      if (!element) return;
      element.style.fontSize = '';
      element.style.lineHeight = '';
      const computed = window.getComputedStyle(element);
      const maxSize = Number.parseFloat(computed.fontSize) || 32;
      const minSize = Math.max(7, maxSize * 0.28);
      const stableLineHeight = Number.parseFloat(computed.lineHeight) || maxSize * 1.12;
      let nextSize = maxSize;
      element.style.whiteSpace = 'nowrap';
      element.style.overflowX = 'hidden';
      element.style.overflowY = 'visible';
      element.style.lineHeight = `${stableLineHeight}px`;
      while (element.scrollWidth > element.clientWidth && nextSize > minSize) {
        nextSize -= 1;
        element.style.fontSize = `${nextSize}px`;
      }
      element.style.overflowX = 'visible';
    };

    const normalizeTextInput = (input) => {
      let nextValue = input.value;
      if (input.dataset.renaoNetflixTextInput === 'year') {
        nextValue = nextValue.replace(/\D/g, '').slice(0, 4);
      }
      if (input.dataset.renaoNetflixTextInput === 'movie-title') {
        nextValue = nextValue
          .toLocaleLowerCase('tr-TR')
          .replace(/(^|\s)(\S)/g, (match) => match.toLocaleUpperCase('tr-TR'));
      }
      const maxLength = Number(input.getAttribute('maxlength') || 0);
      if (maxLength > 0) nextValue = nextValue.slice(0, maxLength);
      if (input.value !== nextValue) input.value = nextValue;
    };

    const slotHasPreviewPhoto = (slotState) => Boolean(
      slotState.objectUrl
      || slotState.existingUrl
      || (slotState.input?.files && slotState.input.files.length > 0)
    );

    const hasCustomTabloCopy = () => {
      if (!isTabloNetflixLayout) return false;
      const hasChangedText = textInputs.some((input) => input.value !== input.defaultValue);
      const selectedColor = menuColorInputs.find((input) => input.checked)?.value || '';
      return hasChangedText || (selectedColor && selectedColor !== initialMenuColor);
    };

    const syncTabloCopyVisibility = () => {
      if (!isTabloNetflixLayout) return;
      const hasAnyPhoto = slots.some(slotHasPreviewPhoto);
      poster.classList.toggle('is-copy-live', hasAnyPhoto || hasActivatedTabloPreview || hasCustomTabloCopy());
    };

    const syncTextPreviews = () => {
      textInputs.forEach((input) => {
        normalizeTextInput(input);
        const key = input.dataset.renaoNetflixTextInput;
        const counter = charCounters.find((item) => item.dataset.renaoNetflixCharCount === key);
        if (counter) {
          const maxLength = Number(input.getAttribute('maxlength') || 0);
          counter.textContent = maxLength ? `${input.value.length}/${maxLength}` : String(input.value.length);
        }
        const previewText = poster.querySelector(`[data-renao-netflix-text-preview="${key}"]`);
        if (!previewText) return;
        if (key === 'year') {
          const isVisible = !dateToggle || dateToggle.checked;
          input.disabled = !isVisible;
          previewText.classList.toggle('is-preview-hidden', !isVisible);
          previewText.textContent = isVisible ? (input.value || input.defaultValue || '') : '';
          return;
        }
        previewText.textContent = input.value || input.defaultValue || '';
        if (['title', 'movie-title', 'names'].includes(key)) {
          window.requestAnimationFrame(() => fitSingleLineText(previewText));
        }
      });
      syncTabloCopyVisibility();
    };

    const syncMenuColor = () => {
      if (!menuColorInputs.length) return;
      const selectedColor = menuColorInputs.find((input) => input.checked)?.value || 'Orijinal';
      const tone = selectedColor === 'Beyaz' ? 'light' : selectedColor === 'Siyah' ? 'dark' : 'original';
      poster.dataset.renaoNetflixMenuTone = tone;
      menuColorInputs.forEach((input) => {
        const isSelected = input.value === selectedColor;
        input.closest('.renao-netflix-menu-color-card')?.classList.toggle('is-selected', isSelected);
      });
      syncTabloCopyVisibility();
    };

    const showProductMedia = () => {
      const mediaWrapper = getProductMediaWrapper();
      if (mediaWrapper) {
        mediaWrapper.classList.remove('has-renao-live-preview');
        mediaWrapper.classList.remove('is-renao-media-returning');
        void mediaWrapper.offsetWidth;
        mediaWrapper.classList.add('is-renao-media-returning');
        window.setTimeout(() => mediaWrapper.classList.remove('is-renao-media-returning'), 900);
      }

      root.classList.remove('has-renao-live-preview');
      if (previewOriginalParent && preview.parentElement !== previewOriginalParent) {
        previewOriginalParent.insertBefore(preview, previewOriginalNext);
      }
    };

    const ensureLivePreviewDock = (mediaWrapper) => {
      let dock = mediaWrapper.querySelector('[data-renao-netflix-live-preview-dock]');
      if (dock) return dock;

      dock = document.createElement('div');
      dock.className = 'renao-live-preview-dock renao-live-preview-dock--netflix';
      dock.dataset.renaoNetflixLivePreviewDock = '';
      dock.innerHTML = `
        <div class="renao-live-preview-dock__bar">
          <span class="renao-live-preview-dock__title">
            <span class="renao-live-preview-dock__mark" aria-hidden="true"></span>
            <span>
              <strong>Live preview</strong>
              <small>Your design before printing</small>
            </span>
          </span>
          <button type="button" data-renao-netflix-show-product-media>Product photos</button>
        </div>
        <div class="renao-live-preview-dock__slot" data-renao-netflix-live-preview-slot></div>
      `;
      mediaWrapper.insertBefore(dock, mediaWrapper.firstChild);
      dock.querySelector('[data-renao-netflix-show-product-media]')?.addEventListener('click', showProductMedia);
      return dock;
    };

    const showLivePreview = () => {
      if (isTabloNetflixLayout) hasActivatedTabloPreview = true;
      syncTextPreviews();
      syncMenuColor();
      const mediaWrapper = getProductMediaWrapper();
      if (!mediaWrapper) return;

      const dock = ensureLivePreviewDock(mediaWrapper);
      const slot = dock.querySelector('[data-renao-netflix-live-preview-slot]');
      if (!slot) return;

      if (preview.parentElement !== slot) slot.appendChild(preview);
      mediaWrapper.classList.remove('is-renao-media-returning');
      mediaWrapper.classList.add('has-renao-live-preview');
      root.classList.add('has-renao-live-preview');
      window.requestAnimationFrame(() => {
        syncTextPreviews();
        syncAllTransforms();
        window.requestAnimationFrame(() => {
          syncTextPreviews();
          syncAllTransforms();
        });
      });
    };

    const hasSlotFile = (slotState) => Boolean(
      slotState.objectUrl
      || slotState.existingUrl
      || (slotState.input?.files && slotState.input.files.length > 0)
    );

    const hasAllPhotos = () => slots.every(hasSlotFile);

    const setInputFile = (input, file) => {
      if (!input || !file) return false;
      input.__renaoPendingFile = file;
      if (typeof DataTransfer === 'undefined') return false;
      try {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
        input.__renaoPendingFile = null;
        return true;
      } catch (error) {
        console.warn('Renao Netflix file could not be assigned to input.', error);
        return false;
      }
    };

    const clearInputFile = (input) => {
      if (!input) return;
      input.__renaoPendingFile = null;
      try {
        if (typeof DataTransfer !== 'undefined') {
          input.files = new DataTransfer().files;
        } else {
          input.value = '';
        }
      } catch (error) {
        input.value = '';
      }
    };

    const getImageUrl = (slotState) => slotState.objectUrl || slotState.existingUrl || '';

    const clampZoom = (value) => clamp(Number(value || 1), 1, 2.8);

    const getStageForSlot = (slotState) => {
      if (activeSlot === slotState && cropStage && !cropModal?.hidden && cropStage.clientWidth && cropStage.clientHeight) return cropStage;
      const previewStage = slotState.image?.parentElement;
      if (previewStage?.clientWidth && previewStage?.clientHeight) return previewStage;
      return null;
    };

    const clampPosition = (slotState) => {
      const stage = getStageForSlot(slotState);
      if (stage && activeSlot === slotState && cropStage && !cropModal?.hidden) {
        slotState.referenceWidth = stage.clientWidth;
        slotState.referenceHeight = stage.clientHeight;
      } else if ((!slotState.referenceWidth || !slotState.referenceHeight) && stage) {
        slotState.referenceWidth = stage.clientWidth;
        slotState.referenceHeight = stage.clientHeight;
      }

      const width = slotState.referenceWidth || stage?.clientWidth || 0;
      const height = slotState.referenceHeight || stage?.clientHeight || 0;
      if (!width || !height) return;
      if (!slotState.normalizedPositionApplied
        && Number.isFinite(slotState.normalizedX) && Number.isFinite(slotState.normalizedY)) {
        slotState.x = slotState.normalizedX * width;
        slotState.y = slotState.normalizedY * height;
        slotState.normalizedPositionApplied = true;
      }
      const maxX = Math.max(0, (width * (slotState.scale - 1)) / 2);
      const maxY = Math.max(0, (height * (slotState.scale - 1)) / 2);
      slotState.x = clamp(slotState.x, -maxX, maxX);
      slotState.y = clamp(slotState.y, -maxY, maxY);
      slotState.normalizedX = slotState.x / width;
      slotState.normalizedY = slotState.y / height;
    };

    const getTransformForStage = (slotState, targetStage) => {
      const referenceWidth = slotState.referenceWidth || cropStage?.clientWidth || targetStage?.clientWidth || 1;
      const referenceHeight = slotState.referenceHeight || cropStage?.clientHeight || targetStage?.clientHeight || 1;
      const ratioX = targetStage?.clientWidth ? targetStage.clientWidth / referenceWidth : 1;
      const ratioY = targetStage?.clientHeight ? targetStage.clientHeight / referenceHeight : 1;
      return `translate(${slotState.x * ratioX}px, ${slotState.y * ratioY}px) scale(${slotState.scale})`;
    };

    const syncSlotTransform = (slotState) => {
      clampPosition(slotState);
      if (slotState.image) {
        const stage = slotState.image.parentElement || cropStage;
        slotState.image.style.transform = stage ? getTransformForStage(slotState, stage) : `scale(${slotState.scale})`;
        slotState.image.style.transformOrigin = 'center';
      }
      if (cropImage && activeSlot === slotState) {
        const stage = cropStage || cropImage.parentElement;
        cropImage.style.transform = stage ? getTransformForStage(slotState, stage) : `scale(${slotState.scale})`;
        cropImage.style.transformOrigin = 'center';
      }
      if (slotState.position) {
        const normalized = Number.isFinite(slotState.normalizedX) && Number.isFinite(slotState.normalizedY)
          ? `, nx:${slotState.normalizedX.toFixed(6)}, ny:${slotState.normalizedY.toFixed(6)}`
          : '';
        const legacy = `x:${Math.round(slotState.x)}, y:${Math.round(slotState.y)}, zoom:${slotState.scale.toFixed(2)}${normalized}`;
        slotState.position.value = globalThis.RenaoCropRecipe?.merge
          ? globalThis.RenaoCropRecipe.merge(slotState.position.value, legacy, slotState.image, slotState.image?.parentElement)
          : legacy;
      }
    };

    const syncAllTransforms = () => slots.forEach(syncSlotTransform);

    const getFileNameFromUrl = (value) => {
      const text = String(value || '');
      try {
        return decodeURIComponent(new URL(text, window.location.origin).pathname.split('/').pop() || text);
      } catch (error) {
        return text.split('/').pop() || text;
      }
    };

    const syncPreservedSlotUrl = (slotState) => {
      if (slotState.existingUrl && !slotState.file) {
        if (!slotState.preserveInput) {
          slotState.preserveInput = document.createElement('input');
          slotState.preserveInput.type = 'hidden';
          slotState.preserveInput.dataset.renaoNetflixExistingPhoto = slotState.slot;
          slotState.upload?.appendChild(slotState.preserveInput);
        }
        slotState.preserveInput.name = slotState.input?.name || `properties[${slotLabels[slotState.slot]}]`;
        slotState.preserveInput.value = slotState.existingUrl;
        slotState.preserveInput.disabled = false;
      } else if (slotState.preserveInput) {
        slotState.preserveInput.value = '';
        slotState.preserveInput.disabled = true;
      }
    };

    const renderSlot = (slotState, shouldAssignInput = true) => {
      const imageUrl = getImageUrl(slotState);
      const hasFile = Boolean(imageUrl);
      if (shouldAssignInput) {
        if (slotState.file) setInputFile(slotState.input, slotState.file);
        else clearInputFile(slotState.input);
      }
      if (slotState.image) {
        if (hasFile) {
          slotState.image.src = imageUrl;
        } else {
          slotState.image.removeAttribute('src');
        }
      }
      slotState.frame?.classList.toggle('has-image', hasFile);
      slotState.upload?.classList.toggle('has-file', hasFile);
      slotState.upload?.classList.remove('has-error');
      if (slotState.fileName) {
        slotState.fileName.textContent = slotState.file?.name || getFileNameFromUrl(slotState.existingUrl) || 'Not Selected';
      }
      if (slotState.adjust) slotState.adjust.hidden = !hasFile;
      const hasAnyPhoto = slots.some((item) => getImageUrl(item));
      poster.classList.toggle('has-renao-photo', hasAnyPhoto);
      poster.classList.toggle('is-live', hasAnyPhoto);
      syncTabloCopyVisibility();
      syncPreservedSlotUrl(slotState);
      syncSlotTransform(slotState);
    };

    const setSlotFile = (slotState, file, shouldAssignInput = true) => {
      if (!file) return;
      if (shouldAssignInput) setInputFile(slotState.input, file);
      if (slotState.objectUrl) URL.revokeObjectURL(slotState.objectUrl);
      slotState.file = file;
      slotState.objectUrl = URL.createObjectURL(file);
      slotState.existingUrl = '';
      slotState.scale = 1;
      slotState.x = 0;
      slotState.y = 0;
      slotState.referenceWidth = 0;
      slotState.referenceHeight = 0;
      root.classList.remove('has-error');
      renderSlot(slotState);
      showLivePreview();
      openCrop(slotState);
    };

    const swapSlotState = (slotState, targetSlotState) => {
      if (!slotState || !targetSlotState || slotState === targetSlotState) return;
      if (slotState.slot === 'main' || targetSlotState.slot === 'main') return;
      const sourceName = slotState.file?.name || getFileNameFromUrl(slotState.existingUrl) || slotLabels[slotState.slot];
      const targetName = targetSlotState.file?.name || getFileNameFromUrl(targetSlotState.existingUrl) || slotLabels[targetSlotState.slot];
      const keys = ['file', 'objectUrl', 'existingUrl', 'scale', 'x', 'y', 'referenceWidth', 'referenceHeight'];
      const temp = {};
      keys.forEach((key) => { temp[key] = slotState[key]; });
      keys.forEach((key) => { slotState[key] = targetSlotState[key]; });
      keys.forEach((key) => { targetSlotState[key] = temp[key]; });

      renderSlot(slotState, true);
      renderSlot(targetSlotState, true);
      syncAllTransforms();
      [slotState.slotElement, targetSlotState.slotElement].forEach((element) => {
        if (!element) return;
        element.classList.remove('is-renao-netflix-swapping');
        void element.offsetWidth;
        element.classList.add('is-renao-netflix-swapping');
        window.setTimeout(() => element.classList.remove('is-renao-netflix-swapping'), 520);
      });
      if (orderStatus) {
        orderStatus.textContent = `${sourceName} ↔ ${targetName}`;
        window.clearTimeout(orderStatus._renaoTimer);
        orderStatus._renaoTimer = window.setTimeout(() => { orderStatus.textContent = defaultOrderHint; }, 1600);
      }
    };

    const openCrop = (slotState) => {
      const imageUrl = getImageUrl(slotState);
      if (!imageUrl || !cropModal || !cropImage || !cropStage) return;
      activeSlot = slotState;
      cropStage.dataset.renaoNetflixCropSlot = slotState.slot;
      cropStage.dataset.renaoNetflixCropLayout = root.dataset.renaoNetflixLayout || '';
      cropImage.src = imageUrl;
      if (cropZoom) cropZoom.value = String(slotState.scale);
      cropModal.hidden = false;
      document.documentElement.classList.add('renao-netflix-crop-open');
      window.requestAnimationFrame(() => syncSlotTransform(slotState));
    };

    const closeCrop = () => {
      if (!cropModal) return;
      cropModal.hidden = true;
      document.documentElement.classList.remove('renao-netflix-crop-open');
      dragState = null;
      activeSlot = null;
    };

    const setZoom = (nextZoom) => {
      if (!activeSlot) return;
      activeSlot.scale = clampZoom(nextZoom);
      if (cropZoom) cropZoom.value = String(activeSlot.scale);
      syncSlotTransform(activeSlot);
    };

    const moveCrop = (direction, amount = 14) => {
      if (!activeSlot) return;
      if (direction === 'up') activeSlot.y -= amount;
      if (direction === 'down') activeSlot.y += amount;
      if (direction === 'left') activeSlot.x -= amount;
      if (direction === 'right') activeSlot.x += amount;
      syncSlotTransform(activeSlot);
    };

    const openProofModal = () => {
      if (!proofModal || !proofStage) return;
      showLivePreview();
      proofStage.innerHTML = '';
      const proofPoster = poster.cloneNode(true);
      const selectedMenuColor = menuColorInputs.find((input) => input.checked)?.value || 'Siyah';
      if (menuColorInputs.length) proofPoster.dataset.renaoNetflixMenuTone = selectedMenuColor === 'Beyaz' ? 'light' : 'dark';
      proofPoster.style.maxWidth = '100%';
      proofStage.appendChild(proofPoster);
      slots.forEach((slotState) => {
        const proofImage = proofPoster.querySelector(`[data-renao-netflix-image-slot="${slotState.slot}"]`);
        if (!proofImage?.parentElement) return;
        proofImage.style.transform = getTransformForStage(slotState, proofImage.parentElement);
        proofImage.style.transformOrigin = 'center';
      });
      const proofFitLines = proofPoster.querySelectorAll('[data-renao-netflix-fit-line], [data-renao-netflix-text-preview="title"]');
      window.requestAnimationFrame(() => {
        proofFitLines.forEach(fitSingleLineText);
        window.setTimeout(() => proofFitLines.forEach(fitSingleLineText), 160);
      });
      const proofPanel = proofModal.querySelector('.renao-proof-modal__panel');
      if (proofPanel) proofPanel.scrollTop = 0;
      proofModal.hidden = false;
      document.documentElement.classList.add('renao-proof-modal-open');
    };

    const closeProofModal = () => {
      if (!proofModal) return;
      proofModal.hidden = true;
      document.documentElement.classList.remove('renao-proof-modal-open');
    };

    const decodeHtmlEntities = (value) => {
      if (typeof value !== 'string') return value;
      const textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return textarea.value;
    };

    const normalizeCartEditProperties = (properties) => {
      if (!properties) return {};
      const normalizeEntry = (result, key, value) => {
        result[decodeHtmlEntities(key)] = decodeHtmlEntities(value);
        return result;
      };

      if (!Array.isArray(properties) && typeof properties === 'object') {
        return Object.entries(properties).reduce((result, [key, value]) => {
          if (Array.isArray(value) && value.length >= 2) return normalizeEntry(result, value[0], value[1]);
          if (value && typeof value === 'object' && value.first) return normalizeEntry(result, value.first, value.last);
          return normalizeEntry(result, key, value);
        }, {});
      }

      if (Array.isArray(properties)) {
        return properties.reduce((result, property) => {
          if (Array.isArray(property) && property.length >= 2) normalizeEntry(result, property[0], property[1]);
          if (property && typeof property === 'object' && property.first) normalizeEntry(result, property.first, property.last);
          return result;
        }, {});
      }

      return {};
    };

    const normalizePropertyKey = (value) => String(value || '')
      .trim()
      .toLocaleLowerCase('tr-TR')
      .replace(/\s+/g, ' ');

    const getPropertyValue = (properties, keys) => {
      const keyList = Array.isArray(keys) ? keys : [keys];
      for (const key of keyList) {
        if (properties[key] !== undefined && properties[key] !== '') return properties[key];
      }

      const normalizedEntries = Object.entries(properties).map(([key, value]) => [
        normalizePropertyKey(key),
        value,
      ]);
      for (const key of keyList) {
        const normalizedKey = normalizePropertyKey(key);
        const match = normalizedEntries.find(([entryKey, value]) => entryKey === normalizedKey && value !== '');
        if (match) return match[1];
      }

      return '';
    };

    const getCartEditKeyFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get('renao_edit');
    };

    const getCartEditState = () => {
      const editKey = getCartEditKeyFromUrl();
      if (!editKey) return null;

      try {
        const savedState = JSON.parse(window.sessionStorage.getItem(`renaoCartEdit:${editKey}`) || 'null');
        if (!savedState) return null;
        savedState.key = savedState.key || editKey;
        savedState.properties = normalizeCartEditProperties(savedState.properties);
        return savedState;
      } catch (error) {
        console.warn('Renao Netflix cart edit state could not be restored.', error);
        return null;
      }
    };

    const fetchCartEditState = (editKey) => {
      if (!editKey) return Promise.resolve(null);

      return fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      })
        .then((response) => response.ok ? response.json() : null)
        .then((cartState) => {
          const item = cartState?.items?.find((cartItem) => cartItem.key === editKey);
          if (!item) return null;

          return {
            key: item.key,
            quantity: item.quantity,
            variantId: item.variant_id,
            properties: normalizeCartEditProperties(item.properties),
          };
        })
        .catch((error) => {
          console.warn('Renao Netflix cart edit state could not be fetched.', error);
          return null;
        });
    };

    const setEditSubmitText = (productForm, attempt = 0) => {
      if (!productForm) return;
      const submitButtonText = productForm.querySelector('[type="submit"] span');
      if (submitButtonText) {
        submitButtonText.textContent = 'Finish Editing';
        return;
      }
      if (attempt < 12) window.setTimeout(() => setEditSubmitText(productForm, attempt + 1), 80);
    };

    const applyGiftWrapEditValue = (productForm, value) => {
      if (!productForm || value === undefined) return;
      const giftWrapSelect = productForm.querySelector('[data-renao-gift-wrap-select]');
      if (!giftWrapSelect) return;
      const option = Array.from(giftWrapSelect.options).find((item) => item.value === value);
      if (option) giftWrapSelect.value = option.value;
    };

    const applyPhotoPositionValue = (slotState, value) => {
      const text = String(value || '');
      if (slotState.position) slotState.position.value = text;
      const x = text.match(/x:([-.\d]+)/);
      const y = text.match(/y:([-.\d]+)/);
      const zoom = text.match(/zoom:([-.\d]+)/);
      const normalizedX = text.match(/(?:^|[,;]\s*)nx:([-.\d]+)/);
      const normalizedY = text.match(/(?:^|[,;]\s*)ny:([-.\d]+)/);

      slotState.x = x ? Number.parseFloat(x[1]) || 0 : slotState.x;
      slotState.y = y ? Number.parseFloat(y[1]) || 0 : slotState.y;
      slotState.scale = zoom ? clampZoom(Number.parseFloat(zoom[1]) || 1) : slotState.scale;
      slotState.normalizedX = normalizedX ? Number.parseFloat(normalizedX[1]) : Number.NaN;
      slotState.normalizedY = normalizedY ? Number.parseFloat(normalizedY[1]) : Number.NaN;
      slotState.normalizedPositionApplied = false;
    };

    const setExistingSlotUrl = (slotState, url) => {
      const normalizedUrl = String(url || '').trim();
      if (!normalizedUrl) return;
      if (slotState.objectUrl) URL.revokeObjectURL(slotState.objectUrl);
      slotState.file = null;
      slotState.objectUrl = '';
      slotState.existingUrl = normalizedUrl;
      renderSlot(slotState, true);
    };

    const applyCartEditState = (editState) => {
      if (!editState || !editState.properties) return;
      const props = editState.properties;
      const productForm = getProductForm();

      if (productForm) {
        productForm.dataset.renaoEditKey = editState.key || '';
        productForm.dataset.renaoEditStorageKey = editState.key ? `renaoCartEdit:${editState.key}` : '';
        setEditSubmitText(productForm);
      }

      slots.forEach((slotState) => {
        const photoUrl = getPropertyValue(props, [slotState.propertyName, slotLabels[slotState.slot], slotFallbackLabels[slotState.slot]]);
        if (photoUrl) setExistingSlotUrl(slotState, photoUrl);
        const positionKey = slotState.slot === 'main'
          ? '_Ana Fotoğraf Konumu'
          : `_Küçük Fotoğraf ${slotState.slot.split('-')[1]} Konumu`;
        const positionValue = getPropertyValue(props, positionKey);
        if (positionValue) applyPhotoPositionValue(slotState, positionValue);
        renderSlot(slotState, true);
      });

      const orderNote = productForm?.querySelector('[data-renao-order-note]');
      if (orderNote && props.Not !== undefined) orderNote.value = props.Not;
      textInputs.forEach((input) => {
        const propertyName = getPropertyNameFromInput(input);
        const value = getPropertyValue(props, propertyName);
        if (value !== '') input.value = value;
        if (input.dataset.renaoNetflixTextInput === 'year' && dateToggle) {
          dateToggle.checked = value !== '';
        }
      });
      if (menuColorInputs.length) {
        const menuColor = getPropertyValue(props, 'Menü Yazı Rengi');
        if (menuColor) {
          const selectedInput = menuColorInputs.find((input) => input.value === menuColor);
          if (selectedInput) selectedInput.checked = true;
        }
        syncMenuColor();
      }
      syncTextPreviews();
      applyGiftWrapEditValue(productForm, props['Hediye Paketi']);
      root.classList.remove('has-error');
      syncAllTransforms();
      if (slots.some((slotState) => getImageUrl(slotState))) showLivePreview();
    };

    const validate = () => {
      const missingSlots = slots.filter((slotState) => !hasSlotFile(slotState));
      root.classList.toggle('has-error', missingSlots.length > 0);
      slots.forEach((slotState) => {
        slotState.upload?.classList.toggle('has-error', missingSlots.includes(slotState));
      });
      return missingSlots;
    };

    slots.forEach((slotState) => {
      slotState.pick?.addEventListener('click', () => {
        showLivePreview();
        slotState.input?.click();
      });
      slotState.frame?.addEventListener('click', () => {
        showLivePreview();
        if (getImageUrl(slotState)) openCrop(slotState);
        else slotState.input?.click();
      });
      slotState.adjust?.addEventListener('click', () => {
        showLivePreview();
        openCrop(slotState);
      });
      slotState.input?.addEventListener('change', () => {
        const file = slotState.input.files && slotState.input.files[0];
        if (!file) return;
        setSlotFile(slotState, file, false);
      });
    });

    slots.forEach((slotState) => {
      const element = slotState.slotElement;
      if (!element || slotState.slot === 'main') return;
      element.addEventListener('dragstart', (event) => {
        draggedSlot = slotState;
        element.classList.add('is-renao-netflix-dragging');
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('text/plain', slotState.slot);
      });
      element.addEventListener('dragenter', (event) => {
        event.preventDefault();
        if (draggedSlot && draggedSlot !== slotState) element.classList.add('is-renao-netflix-drop-target');
      });
      element.addEventListener('dragover', (event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
      });
      element.addEventListener('dragleave', () => {
        element.classList.remove('is-renao-netflix-drop-target');
      });
      element.addEventListener('drop', (event) => {
        event.preventDefault();
        element.classList.remove('is-renao-netflix-drop-target');
        if (!draggedSlot || draggedSlot === slotState) return;
        showLivePreview();
        swapSlotState(draggedSlot, slotState);
      });
      element.addEventListener('dragend', () => {
        element.classList.remove('is-renao-netflix-dragging');
        root.querySelectorAll('.is-renao-netflix-drop-target').forEach((target) => {
          target.classList.remove('is-renao-netflix-drop-target');
        });
        draggedSlot = null;
      });
    });

    cropStage?.addEventListener('pointerdown', (event) => {
      if (!activeSlot) return;
      event.preventDefault();
      event.stopPropagation();
      cropStage.setPointerCapture(event.pointerId);
      dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        originX: activeSlot.x,
        originY: activeSlot.y,
      };
    });

    cropStage?.addEventListener('pointermove', (event) => {
      if (!activeSlot || !dragState || dragState.pointerId !== event.pointerId) return;
      event.preventDefault();
      event.stopPropagation();
      activeSlot.x = dragState.originX + event.clientX - dragState.startX;
      activeSlot.y = dragState.originY + event.clientY - dragState.startY;
      syncSlotTransform(activeSlot);
    });

    cropStage?.addEventListener('pointerup', (event) => {
      event.preventDefault();
      if (dragState?.pointerId === event.pointerId) dragState = null;
    });

    cropStage?.addEventListener('pointercancel', () => { dragState = null; });
    cropStage?.addEventListener('lostpointercapture', () => { dragState = null; });
    cropStage?.addEventListener('dragstart', (event) => event.preventDefault());
    cropStage?.addEventListener('wheel', (event) => {
      if (!activeSlot) return;
      event.preventDefault();
      setZoom(activeSlot.scale + (event.deltaY > 0 ? -0.08 : 0.08));
    }, { passive: false });

    cropZoom?.addEventListener('input', () => setZoom(cropZoom.value));
    cropMoveButtons.forEach((button) => {
      button.addEventListener('click', () => moveCrop(button.dataset.renaoNetflixCropMove));
    });
    cropZoomStepButtons.forEach((button) => {
      button.addEventListener('click', () => setZoom((activeSlot?.scale || 1) + Number(button.dataset.renaoNetflixCropZoomStep || 0)));
    });
    cropReset?.addEventListener('click', () => {
      if (!activeSlot) return;
      activeSlot.scale = 1;
      activeSlot.x = 0;
      activeSlot.y = 0;
      setZoom(1);
    });
    cropApply?.addEventListener('click', closeCrop);
    cropCancelButtons.forEach((button) => button.addEventListener('click', closeCrop));

    proofOpen?.addEventListener('click', openProofModal);
    dateToggle?.addEventListener('change', () => {
      syncTextPreviews();
      showLivePreview();
    });
    menuColorInputs.forEach((input) => input.addEventListener('change', () => {
      syncMenuColor();
      showLivePreview();
    }));
    textInputs.forEach((input) => input.addEventListener('input', () => {
      syncTextPreviews();
      showLivePreview();
    }));
    proofCloseButtons.forEach((button) => button.addEventListener('click', closeProofModal));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (proofModal && !proofModal.hidden) closeProofModal();
        if (cropModal && !cropModal.hidden) closeCrop();
      }
    });

    root.addEventListener('renao:netflix:invalid', () => {
      const missingSlots = validate();
      showLivePreview();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => missingSlots[0]?.pick?.focus?.({ preventScroll: true }), 280);
    });

    root.addEventListener('pointerdown', (event) => {
      if (event.target?.closest?.('[data-renao-netflix-crop], [data-renao-netflix-proof-modal]')) return;
      showLivePreview();
    }, { capture: true });
    root.addEventListener('focusin', showLivePreview);
    root.addEventListener('input', showLivePreview);
    root.addEventListener('change', showLivePreview);

    syncTextPreviews();
    syncMenuColor();
    slots.forEach(renderSlot);
    const editState = getCartEditState();
    if (editState) {
      applyCartEditState(editState);
    } else {
      const editKey = getCartEditKeyFromUrl();
      if (editKey) fetchCartEditState(editKey).then(applyCartEditState);
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-renao-netflix-personalizer]').forEach(initNetflixPersonalizer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
